import { reactiveVueMixin } from '@skinsoft/reactive-vue';

import { mergeMap } from 'rxjs/operators';
import { defineComponent } from 'vue';

import { ThesaurusTermSelectField } from '../thesaurus-term-select-field';

export const ThesaurusSelectField = defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sThesaurusTermSelectField: ThesaurusTermSelectField,
    },
    props: {
        identifier: { type: String, required: true },
    },
    template: require('./thesaurus-select-field.html'),
    data() {
        return {
            id: null as any,
        }
    },
    mounted() {
        this.subscribeToThesaurus();
    },
    beforeUnmount() {
        this.unsubscribeFrom('thesaurus');
    },
    methods: {
        subscribeToThesaurus() {
            this.subscribeTo(
                this.$thesaurusDataStore.fetchOneByIdentifier(this.identifier).pipe(
                    mergeMap(thesaurus => {
                        return this.$thesaurusTermDataStore.fetchRoot(thesaurus.id);
                    }),
                ),
                thesaurusTerms => {
                    this.id = thesaurusTerms[0].id;
                },
                'thesaurus',
            );
        },
    },
    watch: {
        identifier: {
            handler() {
                this.unsubscribeFrom('thesaurus');
                if (this.identifier) {
                    this.subscribeToThesaurus();
                }
            },
            immediate: true,
        },
    },
})
